<template>
  <div class="col-md-6 text-center " id="shareBtns">
    <!-- SNS버튼 시작 -->
    <div style="width: 100%; text-align: center; margin-bottom: 64px;">
      <!-- 페이스북 공유 버튼 -->
      <a href="#" v-on:click="openWindowFb()"><img
              src="@/assets/icon/icon-facebook.png" title="페이스북으로 공유하기"
              class="sharebtn_custom" style="width: 32px;"></a>
      <!-- 트위터 공유 버튼 -->
      <a href="#" v-on:click="openWindowTw()"><img
              src="@/assets/icon/icon-twitter.png" title="트위터로 공유하기" class="sharebtn_custom"
              style="width: 32px;"></a>
      <!-- 카카오 스토리 공유 버튼 -->
      <a href="#" v-on:click="openWindowKs()"><img
              src="@/assets/icon/icon-kakaostory.png" title="카카오스토리로 공유하기"
              class="sharebtn_custom" style="width: 32px;"></a>
      <!-- 밴드 공유 버튼 -->
      <a href="#" v-on:click="openWindowBand()"><img
              src="@/assets/icon/icon-band.png" title="밴드로 공유하기" class="sharebtn_custom"
              style="width: 32px;"></a>
      <!-- 네이버 공유 버튼 -->
      <a href="#" v-on:click="openWindowNaver()"><img
              src="@/assets/icon/icon-naver.png" title="네이버로 공유하기" class="sharebtn_custom"
              style="width: 32px;"></a>  <!-- SNS버튼 끝 -->
    </div>
  </div>
</template>

<script>

  export default {

    name: 'ActivityShow',
    data() {
      return {
        url_default_ks : "https://story.kakao.com/share?url=",
        url_default_fb : "https://www.facebook.com/sharer/sharer.php?u=",
        url_default_tw_txt : "https://twitter.com/intent/tweet?text=",
        url_default_tw_url : "&url=",
        url_default_band : "http://band.us/plugin/share?body=",
        url_route_band : "&route=",
        url_default_naver : "http://share.naver.com/web/shareView.nhn?url=",
        title_default_naver : "&title=",
        url_this_page : location.href,
        title_this_page : document.title,
      }

    },
    methods: {
      openWindowFb() {
        window.open(`${this.url_default_fb}${this.url_this_page}`, '', 'scrollbars=no, width=600, height=600');
        return false;
      },
      openWindowTw() {
        window.open(`${this.url_default_tw_txt + document.title + this.url_default_tw_url + this.url_this_page}`, '', 'scrollbars=no, width=600, height=600');
        return false;
      },
      openWindowBand() {
        window.open(`${this.url_default_band + encodeURI(this.url_this_page) + '%0A' + encodeURI(this.title_this_page) + '%0A' + '&route=tistory.com'}`, '', 'scrollbars=no, width=584, height=635');
        return false;
      },
      openWindowNaver() {
        window.open(`${this.url_default_naver + encodeURI(this.url_this_page) + this.title_default_naver + encodeURI(this.title_this_page)}`, '', 'scrollbars=no, width=600, height=600');
        return false;
      },
      openWindowKs() {
        window.open(`${this.url_default_ks}${this.url_this_page}`, '', 'scrollbars=no, width=600, height=600');
        return false;
      },

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#shareBtns a {
  margin: 2px;
}
</style>
